import { useSupportUserStatus } from "@src/features/tenants";
import { FEATURE_FLAGS, useBooleanFlag } from "@src/services/feature-flags/feature-flags";
import { resolveClipCompilationAccess, type ClipCompilationAccess } from "../access";

/**
 * Single gate for every clip compilation surface — the routes and both nav
 * entry points — so they cannot drift.
 *
 * Two things not to "fix". Gating on the flag store reporting itself
 * initialised never resolves if Amplitude fails to construct, and an unread
 * flag is already `false` so this fails closed anyway. And `getBooleanFlag` in
 * place of `useBooleanFlag` lets the React Compiler freeze the result at its
 * first-render value — see `DumpingSearch.web.tsx`.
 */
export function useClipCompilationAccess(): ClipCompilationAccess {
  const isEnabled = useBooleanFlag(FEATURE_FLAGS.CLIP_COMPILATION);
  const supportStatus = useSupportUserStatus();

  return resolveClipCompilationAccess({ isEnabled, supportStatus });
}
